import { chatWorkerInstance } from './lib/chatWorker';

if (process.env.NODE_ENV === 'development') {
  chatWorkerInstance.setLogger(console);
}

chatWorkerInstance.setSelf(self);
chatWorkerInstance.startup();

